<template>
  <v-container grid-list-xl>

    <v-layout row wrap justify-space-between>
      <v-flex xs12 sm6 lg4>
        <dashcalldist :hourstats="hourstats"></dashcalldist>
      </v-flex>
      <v-flex xs12 sm6 lg4>
        <dashchanstatus :chanstates="channelStates" :numberofchannels="channelCount"></dashchanstatus>
      </v-flex>
      <v-flex xs12 sm6 lg4>
        <dashdevstate :devstates="dev_states"></dashdevstate>
      </v-flex>
      <v-flex xs12>
        <dashchannels :channels="channels"></dashchannels>
      </v-flex>
    </v-layout>

    <!-- <p class="mt-4"></p>
    <dashchannels :channels="channels"></dashchannels> -->


  </v-container>
</template>

<script>
import io from 'socket.io-client'
import Vue from 'vue'
import DashChannels from './dash_channels'
import DashCallDist from './dash_calldist'
import DashChanStatus from './dash_chanstatus'
import DashDevState from './dash_devstate'

export default {
  name: 'dashboard',
  components: {
    dashchannels: DashChannels,
    dashcalldist: DashCallDist,
    dashchanstatus: DashChanStatus,
    dashdevstate: DashDevState
  },
  sockets: {
    connect: function() {
      // socket connected
    },
    disconnect: function () {
      // socket disconnected
    },
    stream_status: function (resp) {
      if (resp.status == 'stopped' && this.restart_stopped_stream) {
        this.restart_stopped_stream = false
        this.start_data_stream()
      }

      if (this.stream_tries > 5) {
        return
      }
      if ('status' in resp) {
        if (resp['status'] == 'error') {
          if ('message' in resp) {
            if ((resp['message'] == 'Already streaming') || (resp['message'] == 'Not logged in')) {
              this.stream_tries += 1
              setTimeout(this.start_data_stream(),200)
            }
          }
        }
      }
    },
    new_channel: function (calldata) {
      let channel = calldata.Channel
      if (!channel) {
        // bad packet. Do not reply to this and let server cancel the feed.
        return
      }

      this.channels.push(calldata)
    },
    upd_channel: function (calldata) {
      let channel = calldata.Channel
      if (!channel) {
        return
      }

      let idx = -1
      this.channels.forEach(function(k,i) {
        if (k.Channel === channel) {
          idx = i
          return
        }
      },this)
      if (idx > -1) {
        this.$set(this.channels,idx,calldata)
      }
    },
    del_channel: function (channel) {
      if (!channel) {
        return
      }

      let idx = -1
      this.channels.forEach(function(k,i) {
        if (k.Channel === channel) {
          idx = i
          return
        }
      },this)
      if (idx > -1) {
        this.$delete(this.channels,idx)
      }
      //Vue.delete(this.channels,channel)
    },
    hourstats_update: function (daystats) {
      this.hourstats = Object.assign({},daystats)
    },
    devstate_update: function (dstate) {
      if (dstate.device === 'undefined') {
        return
      }
      if (!dstate.device) {
        return
      }
      //this.$set(this.dev_states,dstate.device,dstate.status)
      let new_rec = {}
      new_rec[dstate.device] = dstate.status
      this.dev_states = Object.assign({}, this.dev_states, new_rec)
      //this.dev_states[dstate.device] = dstate.status
    }
  },
  data: () => ({
    channels: [],
    hourstats: {},
    dev_states: {},
    restart_stopped_stream: false,
    stream_tries: 0
  }),
  methods: {
    processDataFeed: function () {
      //
    },
    start_data_stream: function () {
      let user = this.$store.getters.auth_user
      let acc = user
      if (user === 'admin') {
        acc = this.admin_account
      }
      this.channels = []
      this.hourstats = {}
      this.dev_states = {}
      this.$socket.emit('start_data_stream',acc,'channels,hourstats,devstate')
    },
    stop_data_stream: function () {
      this.$socket.emit('stop_data_stream')
    }
  },
  computed: {
    admin_account: function () {
      return this.$store.state.admin_selacc
    },
    channelCount: function () {
      return Object.keys(this.channels).length
    },
    channelStates: function () {
      let ret = {}
      this.channels.forEach((channel) => {
        let cstate = channel.ChannelStateDesc || 'Unknown'
        ret[cstate] = ++ret[cstate] || 1
      })
      return ret
    },
    account_code: function () {
      if (this.$store.getters.auth_user === 'admin') {
        return this.$store.state.admin_selacc
      }
      return this.$store.getters.auth_data['account_code']
    }
  },
  watch: {
    account_code: function () {
      this.restart_stopped_stream = true
      this.stop_data_stream()
      this.dev_states = {}
    }
  },
  //beforeMount: function () {
  beforeMount: function () {
    // this.$socket.emit('test','Hello')

    this.start_data_stream()
  },
  beforeDestroy: function () {
    this.stop_data_stream()
  }
}
</script>

<style scoped>
</style>
